import posthog from "posthog-js";

declare global {
  interface Window {
    __autoshortPostHogInitialized?: boolean;
  }
}

const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;
const posthogProxyPath = process.env.NEXT_PUBLIC_POSTHOG_PROXY_PATH || "/_vtx";
const posthogUiHost = process.env.NEXT_PUBLIC_POSTHOG_UI_HOST || "https://eu.posthog.com";
const POSTHOG_DEFAULTS_DATE = "2026-01-30" as const;

function resolveTracingHeaderHost(apiEndpoint: string | undefined, currentHost: string | undefined) {
  if (!apiEndpoint) {
    return null;
  }

  try {
    if (/^https?:\/\//i.test(apiEndpoint)) {
      return new URL(apiEndpoint).host || null;
    }

    if (!currentHost) {
      return null;
    }

    return new URL(apiEndpoint, `https://${currentHost}`).host || null;
  } catch {
    return null;
  }
}

export function getTracingHeaderHosts(apiEndpoint: string | undefined, currentHost: string | undefined) {
  const hosts: string[] = [];

  if (currentHost && !hosts.includes(currentHost)) {
    hosts.push(currentHost);
  }

  const apiHost = resolveTracingHeaderHost(apiEndpoint, currentHost);
  if (apiHost && !hosts.includes(apiHost)) {
    hosts.push(apiHost);
  }

  return hosts;
}

export function getPostHogInitConfig(apiEndpoint: string | undefined, currentHost: string | undefined) {
  return {
    api_host: posthogProxyPath,
    ui_host: posthogUiHost,
    defaults: POSTHOG_DEFAULTS_DATE,
    __add_tracing_headers: getTracingHeaderHosts(apiEndpoint, currentHost),
  };
}

if (typeof window !== "undefined" && posthogKey && !window.__autoshortPostHogInitialized) {
  posthog.init(posthogKey, getPostHogInitConfig(process.env.NEXT_PUBLIC_API_ENDPOINT, window.location.host));

  window.__autoshortPostHogInitialized = true;
}
